import { put, delay } from 'redux-saga/effects';
import { showAlert, hideAlert } from './modules/alert';
import { actions as profileActions } from './modules/profile';
import { positions } from '../components/kit/Alert/positions';
import { history } from '../utils';

export default function* handleSagaError(
  error = {},
  status = 'failure',
  position = positions.TOP_END
) {
  if (error?.type === 'serverError') {
    yield put(showAlert('عدم ارتباط با سرور!'), 'failure');
    yield delay(5000);
    yield put(hideAlert());
    return;
  }

  if (error?.type === 'internet' || error?.message === 'Network Error') {
    yield put(showAlert('لطفا اینترنت خود را چک کنید!', 'failure'));
    yield delay(10000);
    yield put(hideAlert());
    return;
  }

  // if (error?.code === 1003 || error?.data?.code === 1003) {
  //   yield put(profileActions.resetCache());
  //   yield history.replace('/auth/login');
  // }

  if (error?.code === 1010 || error?.data?.code === 1010) {
    yield put(showAlert(error?.message || error?.data?.message, 'failure'));
  }

  // site not found
  if (error?.code === 1700 || error?.data?.code === 1700) {
    yield put(showAlert(error?.message || error?.data?.message, 'failure'));
  }

  if (error?.type >= 500) {
    yield put(showAlert('عدم ارتباط با سرور!'));
    yield delay(10000);
    yield put(hideAlert());
  }
}
